// extracted by mini-css-extract-plugin
export default {"middleContainer":"DH3ewcX6NFFzrZUn32d1","icon":"Qbsx3svXIZnrcbbF8t2m"};